"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Tab = _interopRequireDefault(require("./Tab"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Container = _styledComponents.default.div.withConfig({
  displayName: "Tabs__Container",
  componentId: "design-system__sc-7jo78t-0"
})(["display:flex;button{display:flex;font-family:", ";cursor:pointer;background:none;border:none;font-size:16px;color:", ";text-decoration:none;padding:0px 0px 5px;&:hover{border-bottom:1px solid ", ";}&.active{border-bottom:1px solid ", ";}}button + button{margin-left:25px;}"], _BaseTheme.default.type.family.system, _BaseTheme.default.colors.blue, _BaseTheme.default.colors.blue, _BaseTheme.default.colors.blue);

const Tabs = _ref => {
  let {
    children
  } = _ref;
  const [activeIndex, setActiveIndex] = (0, _react.useState)(0);

  const handleTabClick = tabIndex => {
    if (tabIndex !== activeIndex) {
      setActiveIndex(tabIndex);
    }
  };

  const cloneTabElement = function cloneTabElement(tab) {
    let index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (0, _react.cloneElement)(tab, {
      onClick: () => handleTabClick(index),
      tabIndex: index,
      isActive: index === activeIndex,
      key: index
    });
  };

  const renderChildrenTabs = () => {
    if (!Array.isArray(children)) {
      return cloneTabElement(children);
    }

    return children.map(cloneTabElement);
  };

  const renderActiveTabContent = () => {
    if (children[activeIndex]) {
      return children[activeIndex].props.children;
    }

    return children.props.children;
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, null, renderChildrenTabs()), renderActiveTabContent());
};

Tabs.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.shape({
    type: _propTypes.default.oneOf([_Tab.default]),
    children: _propTypes.default.oneOfType([_propTypes.default.any])
  }), _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.oneOf([_Tab.default]),
    children: _propTypes.default.oneOfType([_propTypes.default.any])
  }))]).isRequired
};
var _default = Tabs;
exports.default = _default;